import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ElementRef,
  ChangeDetectorRef,
  HostListener,
  AfterViewInit,
} from '@angular/core';
import { InOutAnimation } from 'src/app/shared/animations/animations';
import { AnimatedLoaderType } from 'src/app/shared/models/animated-loader-type.enum';

@Component({
  selector: 'app-ai-thinking-loader',
  templateUrl: './ai-thinking-loader.component.html',
  styleUrls: ['./ai-thinking-loader.component.css'],
  animations: [InOutAnimation],
})
export class AiThinkingLoaderComponent implements OnChanges, AfterViewInit {
  @Input() message: string = '';
  /** 🎨 Base gradient colors input (one source of truth) */
  @Input() baseGradientColors: string[] = [
    'rgba(20, 186, 203, 0.5)',
    'rgba(57, 122, 241, 0.83)',
    'rgba(176, 102, 205, 0.93)',
    'rgba(247, 82, 120, 0.5)',
    'rgba(245, 95, 92, 0.5)',
  ];

  // This is what we actually show
  displayMessage: string = '';
  animationClass = '';

  sizesMap = {
    xs: 100,
    sm: 200,
    md: 350,
    lg: 400,
  };

  size: 'xs' | 'sm' | 'md' | 'lg' = 'md';
  @Input('size') set setSize(size: 'xs' | 'sm' | 'md' | 'lg') {
    this.size = size;
  }

  animatedLoaderType = AnimatedLoaderType;
  @Input() type: AnimatedLoaderType = AnimatedLoaderType.ai_loader;
  @Input() animationMode: 'thinking' | 'writing' | 'idle' = 'thinking';

  isPositionTop = false;

  constructor(
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit() {
    this.checkPosition();
  }

  @HostListener('window:scroll')
  @HostListener('window:resize')
  checkPosition() {
    if (!this.el?.nativeElement) return;
    const rect = this.el.nativeElement.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;

    // If less than 100px space below, move to top
    // Only update if changed to prevent unnecessary cycles
    const shouldBeTop = spaceBelow < 120; // 120px threshold for bubble height + spacing
    if (this.isPositionTop !== shouldBeTop) {
      this.isPositionTop = shouldBeTop;
      this.cdr.detectChanges();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['message']) {
      if (this.displayMessage) {
        // Fade out old text first
        this.animationClass = 'animate-fade-out';
        setTimeout(() => {
          this.displayMessage = this.message; // swap after fade-out
          if (this.displayMessage) {
            this.animationClass = 'animate-fade-in';
          }
        }, 400); // duration must match fade-out animation
      } else {
        // First time → just fade in directly
        this.displayMessage = this.message;
        if (this.displayMessage) {
          this.animationClass = 'animate-fade-in';
        }
      }
    }
  }

  getLoaderSize() {
    return this.sizesMap[this.size];
  }

  invertAnimation() {
    this.type =
      this.type === AnimatedLoaderType.ai_loader
        ? AnimatedLoaderType.learmo_loader
        : AnimatedLoaderType.ai_loader;
  }
}
